import styled from 'styled-components';

const Button = styled.button`
  color: var(--white);
  border: 2px solid;
  border-top-color: red;
  border-left-color: deeppink;
  border-right-color: maroon;
  border-bottom-color: mediumvioletred;
  background: var(--black);
  box-sizing: border-box;
  cursor: pointer;
  padding: 16px 24px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  outline: none;
  border-radius: 5px;
  border-top-color: 
  border-right-color:
  border-left-color:
  border-bottom-color: 
  text-decoration: none;
  display: inline-block;
  transition: opacity .3s;
  &:hover,
  &:focus {
    opacity: .5;
  }
`;

export default Button;
